import React from 'react';
import { Text, Container, Grid, Message } from 'basis';
import { LayoutPage, LayoutContent } from 'components';
import { isDJ, byCard, getProductTeamName, byCountry } from 'utils';
import { useStoreValue } from 'store';
import { ResumeOrBackToMerchant } from 'components/merchant/ResumeOrBackToMerchant';
import { PRODUCT_CODE_AU_GEM, PRODUCT_CODE_GO, PRODUCT_CODE_LOW_RATE } from '_config';
import { GreenMessage } from '../../components/message/GreenMessage';

export const SavedConfirmation = () => {
  const [storeState] = useStoreValue();

  const SavedConfirmationNZV2 = () => {
    return (
      <LayoutPage testId="saved" noSessionTimeout noProgressStepper>
        <Container margin="0 0 13 0" hasBreakpointWidth>
          <LayoutContent rowsGap="0">
            <Container padding="0" margin="0">
              <Grid preset="page" colsGap={6}>
                <Grid.Item colSpan="all">
                  <Grid rowsGap={6}>
                    <Container padding="0 0 0 0">
                      <Text>
                        Application reference number:{'\u00A0'}
                        <b>{storeState.applicationRef}</b>
                      </Text>
                    </Container>

                    <GreenMessage>
                      <Message testId="green-message" severity="success">
                        <Text textStyle="heading5" bold="bold">
                          We have saved your application
                        </Text>
                        <Text>We have sent you an email with instructions on how to complete your application.</Text>
                        <br />
                        <Text>
                          Remember, you will need your email address and mobile phone nearby to resume your application.
                        </Text>
                      </Message>
                    </GreenMessage>
                    <Text>The Gem Visa Team</Text>
                    <ResumeOrBackToMerchant />
                  </Grid>
                </Grid.Item>
              </Grid>
            </Container>
          </LayoutContent>
        </Container>
      </LayoutPage>
    );
  };

  const SavedConfirmationAU = () => {
    return (
      <LayoutPage testId="saved" noSessionTimeout noProgressStepper>
        <Container margin="0 0 13 0" hasBreakpointWidth>
          <LayoutContent rowsGap="0">
            <Container padding="0" margin="0">
              <Grid preset="page" colsGap={6}>
                <Grid.Item colSpan="all">
                  <Grid rowsGap={6}>
                    <Container padding="0 0 0 0">
                      <Text>
                        Application reference number:{'\u00A0'}
                        <b>{storeState.applicationRef}</b>
                      </Text>
                    </Container>

                    <GreenMessage>
                      <Message testId="green-message" severity="success">
                        <Text textStyle="heading5" bold="bold" color={isDJ() && 'indigo'}>
                          We have saved your application
                        </Text>
                        <Text color={isDJ() && 'indigo'}>
                          We have sent you an email with instructions on how to complete your application.
                        </Text>
                        <br />
                        <Text color={isDJ() && 'indigo'}>
                          Remember, you will need your email address and the mobile phone{' '}
                          {byCard({
                            [PRODUCT_CODE_GO]: 'nearby',
                            [PRODUCT_CODE_AU_GEM]: 'nearby',
                            [PRODUCT_CODE_LOW_RATE]: 'nearby',
                            default: 'close by',
                          })}{' '}
                          to resume your application.
                        </Text>
                      </Message>
                    </GreenMessage>
                    <Text>
                      {byCard({
                        [PRODUCT_CODE_GO]: 'The',
                        [PRODUCT_CODE_AU_GEM]: 'The',
                        [PRODUCT_CODE_LOW_RATE]: 'The',
                        default: 'Your',
                      })}{' '}
                      {getProductTeamName()} {isDJ() ? 'team' : 'Team'}
                    </Text>
                    <ResumeOrBackToMerchant />
                  </Grid>
                </Grid.Item>
              </Grid>
            </Container>
          </LayoutContent>
        </Container>
      </LayoutPage>
    );
  };
  return byCountry({
    AU: <SavedConfirmationAU />,
    NZ: <SavedConfirmationNZV2 />,
  });
};
